import { Box } from "@mui/material"
import { Check } from "react-feather"
import { ClearFieldButton, FilterButton } from "./common"

export interface FilterToggleButtonProps {
  label: string
  checked?: boolean
  onChange: (checked: boolean) => void
}

/**
 * Controlled toggle filter button.
 * Use `FilterToggle` instead when inside a react-hook-form context.
 */
export const FilterToggleButton = ({
  label,
  checked,
  onChange,
}: FilterToggleButtonProps) => (
  <Box display="flex">
    <FilterButton
      onClick={() => onChange(!checked)}
      disableRipple
      {...(checked
        ? {
            variant: "contained",
            startIcon: <Check />,
            sx: (theme) => ({ pr: `${theme.spacing(2)}!important` }),
          }
        : {
            variant: "outlined",
            sx: {
              "&:hover": {
                backgroundColor: "#f5f8fa",
              },
            },
          })}
    >
      {label}
    </FilterButton>
    {!!checked && <ClearFieldButton onClick={() => onChange(false)} />}
  </Box>
)
